import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const { loginWithGoogleSession } = useAuth();
  const navigate = useNavigate();
  const [status, setStatus] = useState("Autenticando com Google...");

  useEffect(() => {
    // Emergent Managed Google Auth returns session_id in the URL fragment
    const hash = window.location.hash.startsWith("#") ? window.location.hash.slice(1) : window.location.hash;
    const params = new URLSearchParams(hash);
    const session_id = params.get("session_id");
    if (!session_id) {
      setStatus("Sessão inválida — voltando para o login...");
      setTimeout(() => navigate("/login", { replace: true }), 1500);
      return;
    }
    loginWithGoogleSession(session_id)
      .then(() => {
        toast.success("Bem-vindo!");
        navigate("/dashboard", { replace: true });
      })
      .catch((err) => {
        toast.error(err?.response?.data?.detail || "Falha ao autenticar com Google");
        navigate("/login", { replace: true });
      });
  }, [loginWithGoogleSession, navigate]);

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center">
      <div className="text-center">
        <div className="w-12 h-12 mx-auto mb-4 border-4 border-[#00B0F0] border-t-transparent rounded-full animate-spin" />
        <p className="text-sm text-[#475569]">{status}</p>
      </div>
    </div>
  );
}
